import { render } from "./NcrmPrivacyRegistry.vue?vue&type=template&id=7fccba5e&scoped=true"
import script from "./NcrmPrivacyRegistry.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyRegistry.vue?vue&type=script&lang=js"

import "./NcrmPrivacyRegistry.vue?vue&type=style&index=0&id=7fccba5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fccba5e"]])

export default __exports__